// @ts-nocheck
// hooks/useAIGenerator.js
import { useState } from "react";
import { AIService } from "service/AIClients";

export const useAIGenerator = (initialState = {}) => {
	const [options, setOptions] = useState({
		tone: "Résume ce contenu de manière concise et professionnelle pour un public corporate.",
		size: "Résume ce contenu en quelques paragraphes, max 3",
		lang: "en français",
	});

	const updateOption = (key, value) => {
		setOptions((prev) => ({ ...prev, [key]: value }));
	};

	const generateContent = async (
		contentType,
		inputText,
		systemPrompt,
		token
	) => {
		const userPrompt = buildUserPrompt(contentType, inputText, options);
		const messages = [
			{ role: "system", content: systemPrompt },
			{ role: "user", content: userPrompt },
		];

		return await AIService.summarizeText(messages, token);
	};

	const buildUserPrompt = (contentType, inputText, options) => {
		let promptParts = [];
		if (options.tone) promptParts.push(options.tone);
		promptParts.push(`${contentType} : ${inputText}`);
		if (options.size) promptParts.push(options.size);
		if (options.lang) promptParts.push(options.lang);

		return promptParts.join(", ");
	};

	return { options, updateOption, generateContent };
};
